import PropTypes from 'prop-types';
import React from 'react';

import cssColorFromArray from '~app/core/cssColorFromArray';

const MinimapPin = ({locationInfo}) => {
  const gradientId = `MarkerGradient_${
    locationInfo.gradientStartColor[0]}-${
    locationInfo.gradientStartColor[1]}-${
    locationInfo.gradientStartColor[2]}_${
    locationInfo.gradientEndColor[0]}-${
    locationInfo.gradientEndColor[1]}-${
    locationInfo.gradientEndColor[2]}`;

  return (
    <svg className="MinimapMarker" width="17px" height="27px" viewBox="0 0 17 27" version="1.1">
      <defs>
        <linearGradient id={gradientId}
          x1="0" x2="0" y1="0" y2="1"
        >
          <stop
            className="MinimapMarker__gradientStart"
            offset="0%"
            stopColor={cssColorFromArray(locationInfo.gradientStartColor)}
          />
          <stop
            className="MinimapMarker__gradientEnd"
            offset="100%"
            stopColor={cssColorFromArray(locationInfo.gradientEndColor)}
          />
        </linearGradient>
      </defs>
      <g className="MinimapMarker__outer" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g className="MinimapMarker__fill" transform="translate(-793.000000, -2.000000)">
              <g className="MinimapMarker__translate1" transform="translate(-35.000000, -7.000000)">
                  <g className="MinimapMarker__translate2" transform="translate(790.000000, 7.000000)">
                      <path
                        id="MinimapMarker"
                        d="M46.6756757,28.4179104 C45.3618619,28.4179104 54.5585586,15.3341883 54.5585586,10.858209 C54.5585586,6.38222957 51.0292717,2.75373134 46.6756757,2.75373134 C42.3220797,2.75373134 38.7927928,6.38222957 38.7927928,10.858209 C38.7927928,15.3341883 47.9894895,28.4179104 46.6756757,28.4179104 Z"
                        fill={`url(#${gradientId})`}
                      />
                  </g>
              </g>
          </g>
      </g>
    </svg>
  );
};

MinimapPin.propTypes = {
  locationInfo: PropTypes.object.isRequired,
};

export default MinimapPin;



// WEBPACK FOOTER //
// ./src/components/MinimapPin.js